import AppliedFilters from './applied-filters';

export default AppliedFilters;
